import {
  IAddNewBulkBookingsProps,
  IAdministrativeModeDrawerProps,
  IAiConversationDetailsDrawerProps,
  IApiKeyCreateDrawerProps,
  IBackupCreateDrawerProps,
  IBookingFormDrawerProps,
  IBulkActivateShiftTemplateProps,
  IBulkCreateBookingsProps,
  IBulkDriversMessageProps,
  IBulkPassengerNearBySearchDrawerProps,
  IBulkPassengersMessageProps,
  IBulkUpdateBookingsDateTimeProps,
  IBulkUploadBookingsProps,
  ICopyToSupplierPriceRatesProps,
  ICourseEditDrawerProps,
  ICourseSchedulesPreviewDrawerProps,
  IDrawerBookingsProductionProps,
  IDrawerCoursesCalendarRideProduceProps,
  IDrawerCustomProductionProps,
  IDrawerNewOrDuplicateProps,
  IEditAreaWaypointsDrawerProps,
  IEditFormDrawerProps,
  IEtlViewLogsDrawerProps,
  IGenericExportDrawerProps,
  IGenericUploadDrawerProps,
  IHelpTopicDrawerProps,
  IHistoryLogDrawerProps,
  IHubStationsInfoDrawerProps,
  IImportAreasProps,
  IImportBusStationsProps,
  IJourneyDuplicateProps,
  IJourneyEditDrawerProps,
  INotificationEditDrawerProps,
  INotificationsDrawerProps,
  IPriceRateSearchLogsDrawerProps,
  IProcessDrawerProps,
  IProductionPreviewProps,
  IProductionViewLogsDrawerProps,
  IRelatedEntitiesDrawerProps,
  IRideEditFormDrawerProps,
  IRideHistoryLogDrawerProps,
  IStationRouteEditDrawerProps,
  ISupplierPriceRatesPasswordDrawerProps,
  IUpdateBasePriceProps,
  IUserActionsHistoryDrawerProps,
} from "./drawers.models.props";

export type IDrawerVariant = "default" | "custom";

export enum AiAdvisorDetailsTab {
  PlainText = 0,
  FullInfo = 1,
  RawInfo = 2,
  Structure = 3,
}

export enum DrawerType {
  HistoryLog = "HistoryLog",
  EditForm = "EditForm",
  NewOrDuplicate = "NewOrDuplicate",
  CustomProduction = "CustomProduction",
  ProductionPreview = "ProductionPreview",
  ProductionViewLogs = "ProductionViewLogs",
  BulkPassengerNearBySearch = "BulkPassengerNearBySearch",
  BulkPassengersMessage = "BulkPassengersMessage",
  BulkDriversMessage = "BulkDriversMessage",
  EtlViewLogs = "EtlViewLogs",
  GenericExport = "GenericExport",
  GenericUpload = "GenericUpload",
  BulkCreateBookings = "BulkCreateBookings",
  BulkUploadBookings = "BulkUploadBookings",
  BulkUpdateBookingsDateTime = "BulkUpdateBookingsDateTime",
  AddNewBulkBookings = "AddNewBulkBookings",
  Notifications = "Notifications",
  NotificationEditForm = "NotificationEditForm",
  BookingsProduction = "BookingsProduction",
  RideEditForm = "RideEditForm",
  BookingEditForm = "BookingEditForm",
  CourseEditForm = "CourseEditForm",
  CoursesCalendarRideProduce = "CoursesCalendarRideProduce",
  JourneyEditForm = "JourneyEditForm",
  JourneyDuplicate = "JourneyDuplicate",
  StationRouteEditForm = "StationRouteEditForm",
  UpdateBasePrice = "UpdateBasePrice",
  ImportAreas = "ImportAreas",
  ImportBusStations = "ImportBusStations",
  ProcessDrawer = "ProcessDrawer",
  RideHistoryLog = "RideHistoryLog",
  AdministrativeMode = "AdministrativeMode",
  SupplierPriceRatesPassword = "SupplierPriceRatesPassword",
  CopyToSupplierPriceRates = "CopyToSupplierPriceRates",
  BackupCreate = "BackupCreate",
  ApiKeyCreate = "ApiKeyCreate",
  AiConversationDetails = "AiConversationDetails",
  PriceRateSearchLogs = "PriceRateSearchLogs",
  BulkActivateShiftTemplate = "BulkActivateShiftTemplate",
  UserActionsHistory = "UserActionsHistory",
  HelpTopic = "HelpTopic",
  HubStationsInfo = "HubStationsInfo",
  CourseSchedulesPreview = "CourseSchedulesPreview",
  RelatedEntities = "RelatedEntities",
  EditAreaWaypoints = "EditAreaWaypoints",
}

export type DrawerPropsMap = {
  [DrawerType.AddNewBulkBookings]: IAddNewBulkBookingsProps;
  [DrawerType.BookingEditForm]: IBookingFormDrawerProps;
  [DrawerType.BookingsProduction]: IDrawerBookingsProductionProps;
  [DrawerType.EditForm]: IEditFormDrawerProps;
  [DrawerType.GenericExport]: IGenericExportDrawerProps;
  [DrawerType.GenericUpload]: IGenericUploadDrawerProps;
  [DrawerType.BulkPassengerNearBySearch]: IBulkPassengerNearBySearchDrawerProps;
  [DrawerType.BulkPassengersMessage]: IBulkPassengersMessageProps;
  [DrawerType.BulkDriversMessage]: IBulkDriversMessageProps;
  [DrawerType.NewOrDuplicate]: IDrawerNewOrDuplicateProps;
  [DrawerType.RideEditForm]: IRideEditFormDrawerProps;
  [DrawerType.CourseEditForm]: ICourseEditDrawerProps;
  [DrawerType.CoursesCalendarRideProduce]: IDrawerCoursesCalendarRideProduceProps;
  [DrawerType.JourneyEditForm]: IJourneyEditDrawerProps;
  [DrawerType.JourneyDuplicate]: IJourneyDuplicateProps;
  [DrawerType.StationRouteEditForm]: IStationRouteEditDrawerProps;
  [DrawerType.ProductionPreview]: IProductionPreviewProps;
  [DrawerType.Notifications]: INotificationsDrawerProps;
  [DrawerType.NotificationEditForm]: INotificationEditDrawerProps;
  [DrawerType.BulkCreateBookings]: IBulkCreateBookingsProps;
  [DrawerType.BulkUploadBookings]: IBulkUploadBookingsProps;
  [DrawerType.BulkUpdateBookingsDateTime]: IBulkUpdateBookingsDateTimeProps;
  [DrawerType.CustomProduction]: IDrawerCustomProductionProps;
  [DrawerType.HistoryLog]: IHistoryLogDrawerProps;
  [DrawerType.ProductionViewLogs]: IProductionViewLogsDrawerProps;
  [DrawerType.EtlViewLogs]: IEtlViewLogsDrawerProps;
  [DrawerType.UpdateBasePrice]: IUpdateBasePriceProps;
  [DrawerType.ImportAreas]: IImportAreasProps;
  [DrawerType.ImportBusStations]: IImportBusStationsProps;
  [DrawerType.ProcessDrawer]: IProcessDrawerProps;
  [DrawerType.RideHistoryLog]: IRideHistoryLogDrawerProps;
  [DrawerType.AdministrativeMode]: IAdministrativeModeDrawerProps;
  [DrawerType.SupplierPriceRatesPassword]: ISupplierPriceRatesPasswordDrawerProps;
  [DrawerType.CopyToSupplierPriceRates]: ICopyToSupplierPriceRatesProps;
  [DrawerType.BackupCreate]: IBackupCreateDrawerProps;
  [DrawerType.ApiKeyCreate]: IApiKeyCreateDrawerProps;
  [DrawerType.AiConversationDetails]: IAiConversationDetailsDrawerProps;
  [DrawerType.PriceRateSearchLogs]: IPriceRateSearchLogsDrawerProps;
  [DrawerType.BulkActivateShiftTemplate]: IBulkActivateShiftTemplateProps;
  [DrawerType.UserActionsHistory]: IUserActionsHistoryDrawerProps;
  [DrawerType.HelpTopic]: IHelpTopicDrawerProps;
  [DrawerType.HubStationsInfo]: IHubStationsInfoDrawerProps;
  [DrawerType.CourseSchedulesPreview]: ICourseSchedulesPreviewDrawerProps;
  [DrawerType.RelatedEntities]: IRelatedEntitiesDrawerProps;
  [DrawerType.EditAreaWaypoints]: IEditAreaWaypointsDrawerProps;
};

export type DrawerProps<T extends DrawerType> = DrawerPropsMap[T];

export interface IDrawer<T extends DrawerType> {
  drawerProps: DrawerProps<T>;
}
